<div class="bg-[#0A0E1F] text-white font-sans py-10 px-6 md:px-12 lg:px-20">
  <div class="max-w-7xl mx-auto flex flex-col items-center">
    <!-- Heading -->
    <h2 class="lg:text-[22px] font-libre font-bold text-[18px] leading-[27px]">
      <span class="text-[#19E4E0] border-b-2 border-[#19E4E0]">Lottery</span>
      Winner
    </h2>

    <h1 class="text-2xl lg:text-[42px] font-bold mt-2 text-center">
      Recent HighRollers Lottery Champions
    </h1>

    <p class="mt-3 text-[12px] lg:text-[16px] text-gray-400 text-center max-w-2xl">
      Discover the names and prizes of our most recent winners. Your winning
      moment could be next don’t miss the next draw!
    </p>

    <!-- Content Section -->
    <div class="flex flex-col mt-9 w-full">
      <!-- Mobile View -->
      <div *ngIf="lotteryWinner.length > 0" class="sm:hidden space-y-3">
        <div *ngFor="let winner of lotteryWinner; trackBy: trackByIndex" class="flex flex-col gap-2 rounded-lg bg-[#FFFFFF33] p-4 shadow-md">
          <div class="flex justify-between text-sm text-gray-300">
            <span class="font-semibold">{{ winner.winnerName }}</span>
            <div class="flex flex-row gap-1">
              <span class="text-left text-xs leading-tight">{{
                winner.drawDateTime | date : "MMM d, y"
                }}</span>
              <span class="text-right text-xs leading-tight">{{
                winner.drawDateTime | date : "shortTime"
                }}</span>
            </div>
          </div>

          <div class="flex justify-between">
            <div class="text-xl font-bold tracking-wide mt-1">
              {{ winner.winningNumbers }}
            </div>
            <div class="flex items-center gap-2 font-semibold mt-2">
              <img loading="lazy" src="/cmax-assets/icons/gold-money-bag.png" alt="gold bag" class="w-5 h-5" />
              ${{ winner.prize.toLocaleString() }}
            </div>
          </div>
        </div>
      </div>

      <!-- Desktop View -->
      <div *ngIf="lotteryWinner.length > 0" class="hidden sm:block w-full">
        <div class="relative flex justify-center mb-4">
          <div class="transactions-tab">
            <h2 class="transactions-title">Golden Draw</h2>
          </div>
        </div>

        <!-- Table Header -->
        <div
          class="grid grid-cols-[1fr_5fr_4fr_8fr_3fr] text-[#A6B1C2] mb-2 px-5 py-3 rounded-lg bg-[#13192E] backdrop-blur-sm whitespace-nowrap overflow-hidden text-ellipsis">
          <div>Sr</div>
          <div>Winner Name</div>
          <div>Winning Numbers</div>
          <div class="text-center">Prize</div>
          <div>Draw Date & Time</div>
        </div>

        <!-- Table Rows -->
        <div #transactionTable class="space-y-1 h-[32dvh] overflow-y-auto">
          <div *ngFor="let winner of lotteryWinner; let i = index; trackBy: trackByIndex"
            class="grid grid-cols-[1fr_5fr_4fr_8fr_3fr] items-center rounded px-5 py-2 bg-[#FFFFFF33] text-white whitespace-nowrap overflow-hidden text-ellipsis">
            <div>{{ i + 1 }}</div>
            <div class="truncate">{{ winner.winnerName }}</div>
            <div class="truncate">{{ winner.winningNumbers }}</div>
            <div class="flex gap-2 justify-center items-center">
              <img loading="lazy" src="/cmax-assets/icons/gold-money-bag.png" alt="gold bag image" class="w-5 h-5" />
              ${{ winner.prize.toLocaleString() }}
            </div>
            <div class="truncate">
              {{ winner.drawDateTime | date : "medium" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="flex flex-wrap gap-6 justify-center mt-6">
    <div class="flex flex-wrap gap-4 justify-center mt-6">
      <button *ngFor="let tab of displayedTabs" [disabled]="isLoading"
        class="px-5 py-3 rounded-full text-sm font-semibold transition-all duration-200 border" [ngClass]="{
      'text-white bg-gradient-to-r from-purple-600 to-indigo-600 border-purple-600': activeTabId === tab.Id,
      'text-purple-300 bg-transparent border-purple-500 hover:bg-purple-700 hover:text-white': activeTabId !== tab.Id
    }" (click)="selectTab(tab.Id)">
        {{ tab.LotteryName }}
      </button>
    </div>


    <div class="text-center mt-4" *ngIf="originalLotteryList.length > 6">
      <button (click)="showAllTabs = !showAllTabs"
        class="px-5 py-3 text-sm font-semibold transition-all duration-200  mt-3">
        {{ showAllTabs ? 'Show Less' : 'Show More' }}
      </button>
    </div>
  </div> -->

<!-- <hr class="my-6 border-t border-white/30 w-[60%] mx-auto" /> -->

<!-- Winner Cards Section -->
<!-- <div class="px-[70px] mt-8">


    <div *ngIf="isLoading" class="flex justify-center items-center py-10">
      <div class="w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
    <div *ngIf="!isLoading && (lotteryWinners?.length ?? 0) > 0; else noData"
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 justify-center">
      <div *ngFor="let winner of lotteryWinners"
        class="relative w-full max-w-[340px] bg-gradient-to-br from-[#18183a] to-[#2c2b4b] border border-purple-500/20 p-6 md:p-10 lg:p-14 text-center overflow-hidden transition-all duration-300 hover:-translate-y-1 shadow-[0_4px_15px_#1d2227,0_8px_30px_#1d2227] rounded-xl"
        style="clip-path: polygon(50% 0%, 100% 28%, 100% 100%, 0 100%, 0 28%)">

        <div class="relative z-10 flex flex-col items-center">
          <div class="mb-4">
            <ng-container *ngIf="winner.ProfileImage; else noImage">
              <img loading="lazy" [src]="winner.ProfileImage" [alt]="winner.UserName"
                class="w-[5rem] h-[5rem] rounded-full object-cover" />
            </ng-container>
            <ng-template #noImage>
              <div
                class="w-[5rem] h-[5rem] rounded-full flex items-center justify-center bg-purple-700 text-white text-2xl font-bold uppercase shadow-md border border-purple-400">
                {{ winner.UserName?.charAt(0) }}
              </div>
            </ng-template>
          </div>

          <h3 class="text-lg font-bold text-white mb-1 truncate w-full" [title]="winner.UserName">
            {{ winner.UserName }}
          </h3>

          <p class="text-xs md:text-sm text-white mb-6 truncate w-full" [title]="winner.Status">
            {{ winner.Status }}
          </p>

          <div class="mt-auto">
            <span class="block text-sm text-white mb-1">💰 Won:</span>
            <div class="text-3xl font-bold text-purple-500 drop-shadow-[0_2px_10px_rgba(168,85,247,0.3)]">
              ${{ winner.PrizeRank }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noData>
      <div *ngIf="!isLoading" class="text-center text-purple-400 font-semibold text-lg py-10">
        No Data Found
      </div>
    </ng-template>

  </div> -->
